export const PASSWORD_REGEX = /^(?=.*[A-Za-zÀ-ÿ])(?=.*[\d\W]).{8,}$/;

export const PASSWORD_RULES_MESSAGE =
  'A senha deve ter no mínimo 8 caracteres e incluir letras e números ou símbolos.';

export function isValidPassword(password) {
  return PASSWORD_REGEX.test(password);
}
